module.exports = __webpack_public_path__ + "../static/img/base_reap_2900.0732ea1c.png";